import type { QueryClient } from 'react-query'
import { defaultThemeIdPort, type ThemeIdPort } from './themeIdPorts'

export const resolveThemeIdForCustomizationTour = async (
  queryClient: QueryClient,
  themeIdPort: ThemeIdPort = defaultThemeIdPort,
): Promise<string | null> => {
  const cachedThemeId = themeIdPort.fromCache(queryClient)

  if (cachedThemeId) {
    return cachedThemeId
  }

  return Promise.race([
    themeIdPort.fetch(),
    new Promise<null>((resolve) => {
      setTimeout(() => resolve(null), themeIdPort.fetchTimeoutMs)
    }),
  ])
}
